module.exports = __webpack_public_path__ + "static/media/basement.bbb531f5.svg";